"use client";

import { usePathname } from "next/navigation";
import { getActiveContentModalContext } from "@/utils/content-modal-navigation";

export default function useEffectivePathname() {
  const pathname = usePathname();
  const modalContext = getActiveContentModalContext();

  if (modalContext?.backgroundPath) {
    return modalContext.backgroundPath;
  }

  return pathname;
}
